import { render, staticRenderFns } from "./ActivitiesInterface.vue?vue&type=template&id=53f2594f&"
import script from "./ActivitiesInterface.vue?vue&type=script&lang=js&"
export * from "./ActivitiesInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports